// Every English string on the waste screens (Stage 2C), in one place for a
// later Urdu table. Short, plain words for a busy kitchen.
import type { WasteReason } from './wasteTypes'

export const WT = {
  tab: 'Throw away',
  storeTab: 'Waste',
  title: 'Throw something away',
  help: 'Record everything that goes in the bin — what, how much and why. A manager must approve with their PIN.',
  place: 'Where from',
  item: 'What',
  searchItem: 'Search or scan an item…',
  change: 'Change',
  qty: 'How much',
  reason: 'Why',
  batch: 'Which batch',
  batchAuto: 'Oldest / expiring first',
  expired: 'expired',
  expiresIn: (d: number) => (d === 0 ? 'expires today' : `expires in ${d} day${d === 1 ? '' : 's'}`),
  expiredAgo: (d: number) => `expired ${d} day${d === 1 ? '' : 's'} ago`,
  noBatch: 'no expiry',
  has: 'has',
  note: 'Note',
  noteRequired: 'Note (needed for "Other")',
  photo: 'Add photo',
  photoAdded: 'Photo added',
  removePhoto: 'Remove photo',
  value: 'Value',
  valueHint: 'Worked out from what this batch cost.',
  pin: 'Manager PIN',
  save: 'Throw away & record',
  saving: 'Saving…',
  saved: (name: string) => `Recorded: ${name} thrown away`,
  shortfall: (qty: string, unit: string) => `${qty} ${unit} more than the system had here — please count this item soon.`,
  recent: 'Recently thrown away',
  none: 'Nothing thrown away in these days.',
  total: 'Total',
  days: (n: number) => `Last ${n} days`,
  by: 'by',
  approvedBy: 'PIN',
  fromWrapUp: 'after event',
  fromExpiry: 'expiry',
  fromBatch: 'cooking',
  reasons: {
    expired: 'Expired',
    spoiled: 'Spoiled',
    burnt: 'Burnt / overcooked',
    damaged: 'Dropped / damaged',
    leftover: 'Leftover not usable',
    returned: 'Customer returned',
    other: 'Other',
    // Batch 6: written by the server when a batch makes nothing; never picked.
    batch_failed: 'Batch failed — nothing made',
  } satisfies Record<WasteReason, string>,
} as const
